export const Tier0PassiveCollectibles = [
    ['My Reflection', '5'],
    ['Skatole', '9'],
    ['Boom!', '19'],
    ['Dead Bird', '117'],
    ['Pageant Boy', '141'],
    ['Bum Friend', '144'],
    ['Infestation', '148'],
    ['The Black Bean', '180'],
    ['Abel', '188'],
    ['Tiny Planet', '233'],
    ['Key Piece 1', '238'],
    ['Key Piece 2', '239'],
    ['Missing Page 2', '262'],
    ['Best Bud', '274'],
    ['Isaac\'s Heart', '276'],
    ['Strange Attractor', '315'],
    ['Cursed Eye', '316'],
    ['Cain\'s Other Eye', '319'],
    ['Key Bum', '388'],
    ['Betrayal', '391'],
    ['Obsessed Fan', '426'],
    ['My Shadow', '433'],
    ['Linger Bean', '447'],
    ['Shade', '468'],
    ['Hushy', '470'],
    ['Tonsil', '474'],
    ['Knife Piece 1', '626'],
    ['Knife Piece 2', '627'],
    ['Dogma', '633'],
    ['Dad\'s Note', '668'],
];